import { fetchWithNullHandling } from "./fetch";

export interface IAuthResponse {
  successful: boolean;
  message?: string;
  data?: {
    userId: string,
    userEmail: string
  }
}

interface ValidateResponse {
  valid: boolean;
}

interface VerificationResponse {
  success: boolean;
}

/**
 * Check if user is currently logged in
 * @param inUserId - User ID to validate
 * @param inUserEmail - User email to validate
 * @returns true if authenticated (or network error - assume still valid), false only if server explicitly rejects
 */
export async function IsUserLoggedIn(inUserId: string, inUserEmail: string): Promise<boolean> {
  if(!inUserId || !inUserEmail) {
    return false;
  }
  try {
    const r = await fetchWithNullHandling<ValidateResponse>("/api/auth/validate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: inUserId,
        email: inUserEmail
      })
    });

    // Network error - don't sign user out, assume still authenticated
    if(r.error) {
      console.warn("Auth check failed due to network error, assuming still authenticated");
      return true;
    }

    // Got a real response from server - trust it
    return r.data?.valid ?? false;
  }
  catch(err) {
    console.error("Failed to check user logged in status", err);
    return false;
  }
}

/**
 * Verify user email
 */
export async function verify(inEmail: string, inCode: string): Promise<boolean> {
  if(!inEmail || !inCode) {
    return false;
  }
  try {
    const r = await fetchWithNullHandling<VerificationResponse>("/api/auth/verify", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email: inEmail,
        code: inCode
      })
    });
    return r.data?.success ?? false;
  }
  catch(err) {
    console.error("Failed to verify user email", err);
    return false;
  }
}
